export const en = {
    length: '{field} cannot contain more than {max} characters',
    'length-one': '{field} cannot contain more than {max} characters',
    'url-invalid': 'Invalid URL entered',
    'url-scheme-https': 'The URL must specify the https scheme',
    'url-scheme-http-https': 'The URL must specify the http/https scheme',
    email: 'Incorrect email address was entered',
    ascii: '{field} can only contain ASCII characters',
    quoted: '{field} must not be in quotation marks',
    'reserved-words': '{field} cannot contain {words}',
    'forbidden-symbols': '{field} contains forbidden characters',
    'no-letter': '{field} is specified incorrectly',
    'intent-name': 'Invalid format',
    'example-marker': 'Select a marker',
    'example-phrase': 'Select an activation name',
    'example-request': 'Enter a command',
    'example-contains-trigger': 'The request must not contain the words {words}',
    'example-contains-reserved': 'The request must not contain the words {words}',
    'example-contains-activation': 'The request must not contain an activation name',
    'field-common': 'Field',
    'field-name': 'Name',
    'field-developer-name': 'Developer name',
    'field-skill-name': 'Name',
    'field-dialog-name': 'Dialog name',
    'field-activation-name': 'Activation name',
    'field-description': 'Description',
    'field-note': 'The notes field for the moderator',
    'field-subtitle': 'Subtitle',
    'field-id': 'ID',
} as const;

export const ru = {
    length: '{field} не может содержать более {max} символов',
    'length-one': '{field} не может содержать более {max} символа',
    'url-invalid': 'Введён некорректный URL',
    'url-scheme-https': 'В URL должна быть указана схема https',
    'url-scheme-http-https': 'В URL должна быть указана схема http/https',
    email: 'Введен некорректный email',
    ascii: '{field} может содержать только ASCII символы',
    quoted: '{field} не должно быть в кавычках',
    'reserved-words': '{field} не может содержать {words}',
    'forbidden-symbols': '{field} содержит недопустимые символы',
    'no-letter': '{field} указано неверно',
    'intent-name': 'Неверный формат',
    'example-marker': 'Выберите маркер',
    'example-phrase': 'Выберите активационное имя',
    'example-request': 'Введите команду',
    'example-contains-trigger': 'Запрос не должен содержать слова {words}',
    'example-contains-reserved': 'Запрос не должен содержать слова {words}',
    'example-contains-activation': 'Запрос не должен содержать активационное имя',
    'field-common': 'Поле',
    'field-name': 'Имя',
    'field-developer-name': 'Имя разработчика',
    'field-skill-name': 'Название',
    'field-dialog-name': 'Название диалога',
    'field-activation-name': 'Активационное имя',
    'field-description': 'Описание',
    'field-note': 'Поле заметок для модератора',
    'field-subtitle': 'Подзаголовок',
    'field-id': 'ID',
} as const;
